import { parseDate } from "./utils";

export function isWithinDateRange(
  isoDate: string | undefined,
  range: string
): boolean {
  if (!range || range === "all") {return true;}
  if (!isoDate) {return false;}

  const date = parseDate(isoDate);
  if (!date) {return false;}

  const now = new Date();
  const startOfToday = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate()
  );

  switch (range) {
    case "today":
      return date >= startOfToday;
    case "week": {
      const weekAgo = new Date(startOfToday);
      weekAgo.setDate(weekAgo.getDate() - 7);
      return date >= weekAgo;
    }
    case "month": {
      const monthAgo = new Date(startOfToday);
      monthAgo.setMonth(monthAgo.getMonth() - 1);
      return date >= monthAgo;
    }
    case "year": {
      const yearAgo = new Date(startOfToday);
      yearAgo.setFullYear(yearAgo.getFullYear() - 1);
      return date >= yearAgo;
    }
    default:
      return true;
  }
}

export function formatReportDate(iso?: string): string {
  if (!iso) {return "—";}
  const d = parseDate(iso);
  if (!d) {return iso;}
  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}
